import React from "react";
import PageHeader from "../../PageHeader";
import EditSectionForm from "./EditSectionForm";
import { ReactComponent as SectionIcon } from "../../../images/sectionimage/Section.svg";
import { ReactComponent as BackIcon } from "../../../images/pageheadingicon/backicon.svg";
import useStyles from "../../../../styles";

function EditSection() {
  const classes = useStyles();
  const Heading = [
    {
      id: 1,
      pageicon: <SectionIcon />,
      mainheading: "Edit Section",
      // subhead: "Want to Add in Bulk ? ?",
      // downloadlink: "Download bulk Sample Files",
      addbtntext: "Back",
      addbtnicon: <BackIcon />,
      addbtnstyle: "transparentbtn",
      path: "/admin/section",
    },
  ];
  return (
    <div className={`${classes.p2} ${classes.pb0}`}>
      <PageHeader Heading={Heading} />
      <EditSectionForm />
    </div>
  );
}
export default EditSection;
